import _ from 'underscore';

export default class Breakpoint {
  label: string;
  price: any;
  userCount: number;
  isFlatPrice: boolean;
  flatTemplate: any;
  subtotal: any;

  constructor(label: string, price: number, userCount: number, isFlatPrice = false, flatTemplate: any) {
    this.label = label;
    this.price = price;
    this.userCount = userCount;
    this.isFlatPrice = isFlatPrice;
    this.flatTemplate = flatTemplate;
    this.subtotal = isNaN(userCount) ? price : price * userCount;
  }

  toString() {
    let string;

    const i18nUserCount = new Intl.NumberFormat().format(this.userCount);
    const i18nPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    }).format(this.price);

    const templateSettings = {
      interpolate: /\{\{(.+?)\}\}/g
    };

    if (this.isFlatPrice && !!this.flatTemplate) {

      const compiled = _.template(this.flatTemplate, templateSettings);
      string = compiled({
        price: i18nPrice,
        userCount: i18nUserCount
      });
    } else {
      string = `(${i18nUserCount} &times; ${i18nPrice})`;
    }

    return string;
  }
}
